//@flow
import { urlsConstants } from "../_constants/urls.constant";
import { defaultService } from "./defaultService";

export const tituloService = {
  findAll
};

function findAll() {
  return defaultService.doGet(`${urlsConstants.TITULO}findAll`);
}
